import React, { Component } from 'react';
import './App.css';
import rht from './rht';
import web3 from './web3';

class Sell extends Component {
  state = {
    RHTvalueSell: '',
  };

  async componentDidMount() {
    const RHTvalueSell = await rht.methods.showRHTvalueForSellwithoutTrigger().call();
    this.setState({ RHTvalueSell });
  }

  render() {
  return (
    <div className='sell'>
      <p>{(web3.utils.fromWei(this.state.RHTvalueSell, 'ether'))-(web3.utils.fromWei(this.state.RHTvalueSell, 'ether'))%0.0001} BUSD</p>
    </div>
  );
  };
}

export default Sell;